import { render } from "./StaffListOps.vue?vue&type=template&id=2227b606&scoped=true"
import script from "./StaffListOps.vue?vue&type=script&lang=js"
export * from "./StaffListOps.vue?vue&type=script&lang=js"

import "./StaffListOps.vue?vue&type=style&index=0&id=2227b606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2227b606"]])

export default __exports__